import {Constants, ExchangeDispatch, OrderDetail} from '../../../../../core';
import moment from 'moment';
import {DataTable, IconsOfActions} from '../../data-table.interface';
import {environment} from '../../../../../../environments/environment';

export const TYPE_EXCHANGE = {
  PRINT: 'PRINT'
};

const iconsOfActionsList = [
  {
    icon: 'printer',
    tooltip: 'Imprimir etiqueta',
    type: TYPE_EXCHANGE.PRINT,
    hasVisibleCondition: (element: ExchangeDispatch[]) => {
      return element.length ==1 ;
    }
  }
];
export const exchangeManagement: DataTable = {
  searchText: '',
  addText: '',
  export: true,
  exportFile: 'Reporte de Cambios y Devoluciones.xlsx',
  expandable: true,
  filter: false,
  paginator: true,
  iconsOfActions: iconsOfActionsList,
  filterDefault: '',
  disabled: false,
  partialField: '',
  checkbox: true,
  checkboxHeader: true,
  showIcon: './assets/icon/ico_placeholder_documentos.svg',
  hasDisabledCheckBoxItem: (item) => item.dispatchTypeCode == Constants.Dispatch.dispatchType.NORMAL,
  columns: [
    {
      title: 'N° de NV',
      name: 'saleNoteNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w130',
      value: (element: ExchangeDispatch) => element.saleNoteNumber
    },
    {
      title: 'N° de Despacho',
      name: 'dispatchNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: ExchangeDispatch) => element.dispatchNumber
    },
    {
      title: 'Cliente',
      name: 'customerName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: ExchangeDispatch) => element.customerName
    },
    {
      title: 'N° de Doc.',
      name: 'customerDocumentNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: ExchangeDispatch) => element.customerDocumentNumber
    },
    {
      title: 'Entidad de Venta',
      name: 'saleEntityName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: ExchangeDispatch) => element.saleEntityName
    },
    {
      title: 'Tipo de despacho',
      name: 'dispatchTypeName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: ExchangeDispatch) => element.dispatchTypeName
    },
    {
      title: 'Última Entidad',
      name: 'lastEntityName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: ExchangeDispatch) => element.lastEntityName
    },
    {
      title: 'Fecha de entrega',
      name: 'deliveryDate',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left w120',
      value: (element: ExchangeDispatch) => element.deliveryDate ? moment(element.deliveryDate).format('YYYY-MM-DD') : '---'
    }

  ],
  subTable: {}
};
